import { Box, Button, Dialog, DialogActions, DialogTitle, IconButton, } from '@mui/material';
import { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useForm } from 'react-hook-form';

export const CustomDialog = ({ row, handleDeleteRow, isLoading, endPoint }) => {
    const [open, setOpen] = useState(false);

    const { reset, } = useForm({
        mode: 'onChange',
    })
    const handleClickOpen = () => {
        setOpen(true);
    };


     const handleClose = () => {
        setOpen(false);
    };

    const handleAccept = async () => {
           await handleDeleteRow(row, {isActivated :  row.isActivated === "1" ?  "0" : "1"})
            handleClose();
            reset();
    };

     return (
        <Box>
        <Button size='small' onClick={handleClickOpen} color={ row.isActivated==="1" ? "error" : "primary"} sx={{fontSize: "10px", textWrap:"nowrap"
            
        }}>{row.isActivated==="1" ? "Deactivate" : "Activate"}</Button>
            <Dialog open={open} onClose={handleClose} sx={{ "& .MuiDialog-paper":{
                width: "500px"
            
            } }}>
                <DialogTitle>Are you sure you want to deactivate this record? If you deactivate this record, user will not be able to access the system.
                    <IconButton style={{ position: 'absolute', right: '8px', top: '12px' }} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton></DialogTitle>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" disabled={isLoading} sx={{ minWidth: "150px" }}>
                        No
                    </Button>
                    <Button onClick={handleAccept} color="primary" disabled={isLoading} sx={{ minWidth: "150px" }}>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

        </Box>

    );
};

export default CustomDialog;